import React from "react";
import { Col, Modal, Row } from "antd";
import "../../../../assets/style/modalStyle/postNews.scss";
import TranslateText from "../../TranslateText";

import ItemProductPreview from "../../ItemProductPreview";
import { storeProductSelector } from "../../../../services/selector/index.";
import { useSelector } from "react-redux";
import InputSearchBox from "../../Input/InputSearchBox";
import "../../../../assets/style/modalStyle/previewProduct.scss";
const ModalPreviewProduct = ({ open, setOpen }) => {
  const stateStore = useSelector(storeProductSelector);
  const { data } = stateStore;
  const handCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text="Xem trước" />}
        centered
        width={1300}
        open={open}
        onCancel={handCancel}
        className="modalPreviewProduct"
        footer={[]}
        style={{ minHeight: "50%" }}
      >
        <div className="wrapperPreviewProduct">
          <Row className="title">
            <Col span={12}>
              <h1>
                <TranslateText text={"Cửa hàng Bkav"} />
              </h1>
            </Col>
            {/* <Col span={12}>
              <InputSearchBox disabled={true} placeholder={"Tìm kiếm"} />
            </Col> */}
          </Row>
          <div className="content">
            {data
              ? data.map((item) => (
                  <ItemProductPreview key={item.id} data={item} />
                ))
              : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalPreviewProduct;
